<div class="blog-list-wrapper">
  @for (blog of blogs(); track blog.slug) {
    <div class="blog-card" [style.backgroundColor]="blog.cover_bg_color">
      <div class="blog-image">
        <img
          [src]="blog.cover_image"
          [alt]="blog.title"
          loading="{{ $index < 4 ? 'eager' : 'lazy' }}"
        />
      </div>
      <div class="blog-content">
        <h2
          class="blog-title"
          [style.color]="getTextColor(blog.cover_bg_color)"
        >
          {{ blog.title }}
        </h2>
        <div
          class="blog-meta"
          [style.color]="getTextColor(blog.cover_bg_color)"
        >
          <div
            class="category"
            [class.expanded]="expandedCategories[blog.slug]"
            (click)="toggleCategories(blog.slug)"
            (mouseenter)="expandCategories(blog.slug)"
            (mouseleave)="collapseCategories(blog.slug)"
            style="--number-of-catergories: {{ blog.categories.length }}"
          >
            @for (category of blog.categories; track $index) {
              <span
                >{{ category }}
                @if (blog.categories.length > 1 && $index === 0) {
                  <span [class.v-hidden]="expandedCategories[blog.slug]">
                    + {{ blog.categories.length - 1 }}</span
                  >
                }
              </span>
            }
          </div>
          <div>
            <span class="author"
              >{{ blog.author.first_name }} {{ blog.author.last_name }}</span
            >
            <span class="date">{{ blog.timestamp | date: "MMMM d, y" }}</span>
          </div>
        </div>
        <p
          class="blog-description"
          [style.color]="getTextColor(blog.cover_bg_color)"
        >
          {{ blog.snippet }}
        </p>
        <div class="read-more-container">
          <a
            [routerLink]="['/blog', blog.slug]"
            class="read-more"
            [style.color]="getTextColor(blog.cover_bg_color)"
          >
            Read more →
          </a>
        </div>
      </div>
    </div>
  }
</div>
